import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { NavigationMenuSelection } from "../interfaces/navigation_menu.interface";
import { normalizeNavigationSourceSelection } from "../utils/navigation_source_selection.util";

function normalizeSelection(selection: NavigationMenuSelection | null | undefined): NavigationMenuSelection | null {
    if (!selection) {
        return null;
    }

    const section = typeof selection.section === "string" ? selection.section.trim() : "";
    const target = typeof selection.target === "string" ? selection.target.trim() : "";

    if (!section || !target) {
        return null;
    }

    return {
        section,
        target,
        sourceSelection: normalizeNavigationSourceSelection(selection.sourceSelection)
    };
}

@Injectable({ providedIn: "root" })
export class FormNavigationDispatcherService {
    private readonly navigationRequestsSubject = new Subject<NavigationMenuSelection>();

    readonly navigationRequests$: Observable<NavigationMenuSelection> = this.navigationRequestsSubject.asObservable();

    requestNavigation(selection: NavigationMenuSelection | null | undefined): void {
        const normalized = normalizeSelection(selection);

        if (!normalized) {
            return;
        }

        this.navigationRequestsSubject.next(normalized);
    }
}
